module.exports = __webpack_public_path__ + "img/cs-banner.c7ba5dcc.png";